import { GetStaticPaths, GetStaticProps } from 'next';

import FullScreenLoader from '@components/FullScreenLoader';
import MarketDetailsPageView from '@components/MarketDetailsPageView';
import Seo from '@components/Seo';
import useSupportedAsset from '@hooks/useSupportedAsset';

interface MarketTokenPageProps {
  assetSymbol: string;
}

function MarketTokenPage({ assetSymbol }: MarketTokenPageProps): JSX.Element {
  const asset = useSupportedAsset(assetSymbol);

  if (!asset) {
    return (
      <>
        <Seo
          title="Tectonic | Cross-chain Money Market | Lending & Borrowing"
          description="Generate passive yield on your assets earn attractive APYs based on a dynamic rate or Get an instant loan quickly and easily by using USDC, WBTC, WETH, CRO as collateral with more supported coins to come."
        />
        <FullScreenLoader />
      </>
    );
  }

  return (
    <>
      <Seo
        title="Tectonic | Cross-chain Money Market | Lending & Borrowing"
        description="Generate passive yield on your assets earn attractive APYs based on a dynamic rate or Get an instant loan quickly and easily by using USDC, WBTC, WETH, CRO as collateral with more supported coins to come."
      />
      <MarketDetailsPageView asset={asset} mode="MAIN" />
    </>
  );
}

export default MarketTokenPage;

export const getStaticProps: GetStaticProps<MarketTokenPageProps> = (
  context
) => {
  let assetSymbol = '';

  if (typeof context.params?.assetSymbol === 'string') {
    assetSymbol = context.params.assetSymbol;
  }

  return { props: { assetSymbol } };
};

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [
      { params: { assetSymbol: 'cro' } },
      { params: { assetSymbol: 'dai' } },
      { params: { assetSymbol: 'tonic' } },
      { params: { assetSymbol: 'tusd' } },
      { params: { assetSymbol: 'usdc' } },
      { params: { assetSymbol: 'usdt' } },
      { params: { assetSymbol: 'wbtc' } },
      { params: { assetSymbol: 'btc' } },
      { params: { assetSymbol: 'weth' } },
      { params: { assetSymbol: 'eth' } },
      { params: { assetSymbol: 'atom' } },
      { params: { assetSymbol: 'xrp' } },
      { params: { assetSymbol: 'ada' } },
      { params: { assetSymbol: 'vvs' } },
      { params: { assetSymbol: 'ltc' } },
      { params: { assetSymbol: 'lcro' } },
      { params: { assetSymbol: 'cdcbtc' } },
      { params: { assetSymbol: 'cdceth' } },
    ],
    fallback: false,
  };
};
